import { ALERTS_IDS, CONFIRMS_IDS } from '../constants/notifierConstants';

export const alertInitialState = {
  title: '',
  content: '',
  type: 'info',
  show: false,
  duration: 10, // Seconds
  dismissable: false,
};

export const alertsInitialState = {
  [ALERTS_IDS.wbapp]: { ...alertInitialState, id: ALERTS_IDS.wbapp },
  [ALERTS_IDS.grItemNode]: { ...alertInitialState, id: ALERTS_IDS.grItemNode },
  [ALERTS_IDS.hdModal]: { ...alertInitialState, id: ALERTS_IDS.hdModal },
  [ALERTS_IDS.hdTreeExport]: { ...alertInitialState, id: ALERTS_IDS.hdTreeExport },
  [ALERTS_IDS.hdTreeImport]: { ...alertInitialState, id: ALERTS_IDS.hdTreeImport },
  [ALERTS_IDS.irdCsv]: { ...alertInitialState, id: ALERTS_IDS.irdCsv },
  [ALERTS_IDS.irdModal]: { ...alertInitialState, id: ALERTS_IDS.irdModal },
  [ALERTS_IDS.sbMenuLinkEditor]: {
    ...alertInitialState,
    id: ALERTS_IDS.sbMenuLinkEditor,
  },
  [ALERTS_IDS.sbImageEditor]: {
    ...alertInitialState,
    id: ALERTS_IDS.sbImageEditor,
  },
  [ALERTS_IDS.sbQREditor]: {
    ...alertInitialState,
    id: ALERTS_IDS.sbQREditor,
  },
  [ALERTS_IDS.sbServiceLinkEditor]: {
    ...alertInitialState,
    id: ALERTS_IDS.sbServiceLinkEditor,
  },
};

export const confirmInitialState = {
  title: '',
  buttons: {
    confirm: 'OK',
    cancel: 'CANCEL',
  },
  content: null,
  isOpened: false,
  isDeclined: false,
  isConfirmed: false,
};

export const confirmsInitialState = {
  [CONFIRMS_IDS.wbapp]: { ...confirmInitialState, id: CONFIRMS_IDS.wbapp },
  [CONFIRMS_IDS.sbImageEditor]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.sbImageEditor,
  },
  [CONFIRMS_IDS.sbQREditor]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.sbQREditor,
  },
  [CONFIRMS_IDS.sbServiceLinkEditor]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.sbServiceLinkEditor,
  },
  [CONFIRMS_IDS.sbMenuLinkEditor]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.sbMenuLinkEditor,
  },
  [CONFIRMS_IDS.hbSlideEditor]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.hbSlideEditor,
  },
  [CONFIRMS_IDS.guestRequestNodeCategory]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.guestRequestNodeCategory,
  },
  [CONFIRMS_IDS.irdCategoryEditor]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.irdCategoryEditor,
  },
  [CONFIRMS_IDS.irdNodeItem]: {
    ...confirmInitialState,
    id: CONFIRMS_IDS.irdNodeItem,
  },
};

export const notifierInitialState = {
  alert: alertsInitialState,
  confirm: confirmsInitialState,
};
